module.exports = __webpack_public_path__ + "static/boots_of_speed-d994180f134335d56ee9d3e2306ad65a.jpeg";